const blockingToast = (state = null, action) => {
  if (action.type === "SET_BLOCKING_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_BLOCKING_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default blockingToast;
